/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EventModel } from './EventModel';
import {
    EventModelFromJSON,
    EventModelFromJSONTyped,
    EventModelToJSON,
} from './EventModel';
import type { FormFieldCheckboxValueModel } from './FormFieldCheckboxValueModel';
import {
    FormFieldCheckboxValueModelFromJSON,
    FormFieldCheckboxValueModelFromJSONTyped,
    FormFieldCheckboxValueModelToJSON,
} from './FormFieldCheckboxValueModel';

/**
 * 
 * @export
 * @interface FormFieldCheckboxModel
 */
export interface FormFieldCheckboxModel {
    /**
     * 
     * @type {string}
     * @memberof FormFieldCheckboxModel
     */
    label?: string;
    /**
     * 
     * @type {FormFieldCheckboxValueModel}
     * @memberof FormFieldCheckboxModel
     */
    value?: FormFieldCheckboxValueModel;
    /**
     * 
     * @type {boolean}
     * @memberof FormFieldCheckboxModel
     */
    isChecked?: boolean;
    /**
     * 
     * @type {EventModel}
     * @memberof FormFieldCheckboxModel
     */
    event?: EventModel;
}

/**
 * Check if a given object implements the FormFieldCheckboxModel interface.
 */
export function instanceOfFormFieldCheckboxModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FormFieldCheckboxModelFromJSON(json: any): FormFieldCheckboxModel {
    return FormFieldCheckboxModelFromJSONTyped(json, false);
}

export function FormFieldCheckboxModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormFieldCheckboxModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'label': !exists(json, 'label') ? undefined : json['label'],
        'value': !exists(json, 'value') ? undefined : FormFieldCheckboxValueModelFromJSON(json['value']),
        'isChecked': !exists(json, 'isChecked') ? undefined : json['isChecked'],
        'event': !exists(json, 'event') ? undefined : EventModelFromJSON(json['event']),
    };
}

export function FormFieldCheckboxModelToJSON(value?: FormFieldCheckboxModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'label': value.label,
        'value': FormFieldCheckboxValueModelToJSON(value.value),
        'isChecked': value.isChecked,
        'event': EventModelToJSON(value.event),
    };
}

